import { action } from 'typesafe-actions';

import ActionTypes from './constants';

export const storeSearch = (pathname: string, search: string) =>
  action(ActionTypes.STORE_SEARCH, { pathname, search });
